// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__cXwzs","step":"Steps_step__5q9la","stepNo":"Steps_stepNo__vS7g5","stepLabel":"Steps_stepLabel__+x9Fk","done":"Steps_done__Z2LoD","now":"Steps_now__E3Sfx"};